import * as yup from 'yup';

export const CommentationSchema = yup.object({
  comment: yup.string().required().max(3000),
});

export interface ICommentation {
  comment: string;
}
